export default {
  storageName: 'arenaxstorage',
  arenaUrl: 'https://arena51.arkadiumarena.com',
  apiUrl: 'https://arenax-api-admin-live.arkadiumhosted.com/api/v1',
  gameApiUrl: 'https://game-api-fd-live.arkadiumhosted.com',
  sentryDsn: 'https://0491ba8df8cb1ff95140abae42591b70@sentry.arkadiumhosted.com/61',
  sentryEnvironment: 'live',
  msalConfig: {
    auth: {
      authority: 'https://login.microsoftonline.com/7945008c-5c1b-42a9-a1c3-7f3d3642da94',
      clientId: 'aee7f493-cb8e-48ab-9823-9a9c6ec25ad5',
    },
    cache: {
      cacheLocation: 'localStorage'
    },
  }
};


